import { DrawingService, retracementeMenuParams, DGDrawingServiceGlobal } from '../Services/DrawingService';
import { retracementTimeRangeCartessians } from "../Services/RetracementAccesability.service";
import { MouseEventParams } from "./lcharts/src/api/create-chart";
import * as jQuery from "jquery";
import { LoggerService } from '../Services/Logger/Logger';
export class RetracementMenu {

  constructor(public drawingService: DrawingService) {

  };


  public searchClickedRetracement(param: MouseEventParams) {
    let price = [...param.seriesPrices.values()][0];
    //console.log(this.drawingService.excludeService.retracementTimeRangeMap);



    //console.log(this.drawingService.excludeService.retracementTimeRangeMap);//


    let result = [...this.drawingService.excludeService.retracementTimeRangeMap.values()].filter(
      (item: retracementTimeRangeCartessians) => {

        let aB = this.drawingService.activeRetracements.excludesService.activeBars.get(item.serieIndex);

       // if (!aB) return false;

        let price = this.drawingService.chart.chart.getChartModel().mainPriceScale().coordinateToPrice(param.point.y, 0);


        let checkX = param.point.x >= item.startX && param.point.x <= item.endX;
        let checkPrice = price >= item.priceStart && price <= item.priceEnd;

        return checkX && checkPrice;
      });

   let availabledIndexes = result.map(v=>{
     return v.serieIndex
   })
    if (result.length > 0) {

      let finded = [...this.drawingService.activeRetracements.activeRetracements.values()].filter(v => {
        return  !v.expanded && availabledIndexes.indexOf(v.retracement.baseLine.getSerieIndex())>-1;
      })

      //console.log(finded);

      if(finded.length>0)
      {


      let menuData = new retracementeMenuParams();
      menuData.param = {
        point: {
          x: param.point.x,
          y: param.point.y
        }
      };
      menuData.retracement = finded[0];

      this.drawingService.retracementMenuActioner.next(menuData);
    }

    }
  }

  public drawOrUpdateShrinks(range: retracementTimeRangeCartessians) {


    jQuery('.rItem').remove();

    ////console.log(this.drawingService.excludeService.retracementTimeRangeMap)

    let rList = [...this.drawingService.excludeService.retracementTimeRangeMap.values()];

    rList.forEach(item => {

      try {
        let finded = [...this.drawingService.activeRetracements.activeRetracements.values()].find(v => {
          return v.retracement.baseLine.getSerieIndex() == item.serieIndex
        })

        if (finded) {


          let y = this.drawingService.chart.chart.getChartModel().mainPriceScale().priceToCoordinate(item.priceEnd, 0);

      //    var t = DGDrawingServiceGlobal.drawingService().chart.chart.timeScale().timeToCoordinate(tm);
         // let x = this.drawingService.chart.chart.getChartModel().timeScale()

          if (finded.retracement.waveType == "DOWNWAVE") {
            y = this.drawingService.chart.chart.getChartModel().mainPriceScale().priceToCoordinate(item.priceStart, 0);
          }

          let id = `ritem_${item.serieIndex}`;
          let visibility = "visibility:visible";

          let canvasHeight =jQuery("#tist_0").height()

          if (finded.expanded == true) {

            if(item.startX<5 || y>canvasHeight)
            {
              visibility = "visibility:hidden";
            }

            jQuery("#chartWrapper").append(`<div att-id="${item.serieIndex}" style="top: ${y}px; left: ${item.startX}px; ${visibility}"  class='rItem' id='#${id}'>-</div>`);

            let rId = `#${id}`
          }
        }
      }
      catch (e) {
        LoggerService.logError(e);
      }

    })

    jQuery('.rItem').on("click", function () {

      let index = Number(jQuery(this).attr("att-id"));

      let finded = [...DGDrawingServiceGlobal.drawingService().activeRetracements.activeRetracements.values()].find(v => {
        return v.retracement.baseLine.getSerieIndex() == index;
      })

      let menuData = new retracementeMenuParams();
      menuData.param = {
        point: {
          x: jQuery(this).position().left,
          y: jQuery(this).position().top
        }
      };
      menuData.retracement = finded;

      DGDrawingServiceGlobal.drawingService().retracementMenuActioner.next(menuData);
    });

  }


}

export function rClickAction(v) {
  alert(v)
}
